/* eslint-disable class-methods-use-this */
import axios from 'axios';

import { getAuthToken } from './auth.service';

const headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'DELETE',
};

class DeleteHelper {
  async delete(url:string) {
    const response = await axios
      .delete(url, { headers });
    return response;
  }
}
export default new DeleteHelper();
